import { ListingType } from "./listingTypes";

export const initialState: ListingType = {
  fetching: false,
  success: null,
  error: null,
  statusCode: null,
  jobTrackerListing: [],
  jobProgressCommentsFetching: false,
  jobProgressCommentsList: [],
  jobProgressCommentsSuccess: null,
  openJobsListing: [],
  documentsLinkList: [],
  assignedClientsOpenJobsList: [],
  allOpenItemsList: [],
  fileFolderCount: [],
  invoiceCount: [],
  openJobsListingTotalCount: "",
  dailyActiveUserList: [],
  userSessionLoginCountList: [],
  monthlyActiveUserList: [],
  userReportList: [],
  userWiseInvoiceCountReportList: [],
  allEwayBillEInvoiceList: [],
  allClientLockDateList:[],
  allClientLockDateTotalCount:0,
  allExternalUserEmailerList:[],
  allExternalUserEmailerTotalCount:0,
  invoiceCountGraphData:[],
  allUserApprovedEntryList:[],
  allUserApprovedEntryTotalCount:0,
  allClientBulkUploadList:[],
  allClientBulkUploadTotalCount:0

};
